import { createSelector } from 'reselect';
import { RootState } from '@reducers';
import { ProfileState } from '@reducers/profile';

export const getProfile = (state: RootState): ProfileState => state.profile;
export const getProfileData = createSelector(getProfile, (profile) => profile?.data);
export const getProfileIsLoading = createSelector(getProfile, (profile) => profile?.loading);
